export default "__VITE_ASSET__9ad6aed8__"